import React from "react";
import PropTypes from "prop-types";

import { HeaderButton } from "components/ui/HeaderButton";

function UserButton({ onClick, children, active, node, ...rest }) {
  return (
    <HeaderButton
      data-testid="user-button"
      onClick={onClick}
      className={active ? "active" : null}
      ref={node}
      {...rest}
    >
      <div style={{ display: `flex`, alignItems: `center` }}>
        <span className="spacer" />
        {children}
      </div>
    </HeaderButton>
  );
}

UserButton.propTypes = {
  firstName: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  active: PropTypes.bool,
  node: PropTypes.any,
};
UserButton.displayName = "UserButton";
export default UserButton;
